import React from 'react'
import { IVariationContainer } from 'marketing-site/@types/generated/contentful'
import { Entry } from 'contentful'
import { ContentfulOptimizelyVariationContainer } from './ContentfulOptimizelyVariationContainer'
import { ContentfulMutinyVariationContainer } from './ContentfulMutinyVariationContainer'

export function isVariationContainer(entry: Entry<any>): entry is IVariationContainer {
  return entry.sys.contentType?.sys.id === 'variationContainer'
}

export function ContentfulVariationContainer(
  variationContainer: IVariationContainer & { children?: React.ReactNode },
): React.ReactElement | null {
  const { experimentApp } = variationContainer.fields
  if (experimentApp === 'mutiny') {
    return <ContentfulMutinyVariationContainer {...variationContainer} />
  } else {
    return <ContentfulOptimizelyVariationContainer {...variationContainer} />
  }
}
